// Phase 1A · Step 26/42 — /brief/history page (Phantom slip history).
//
// Step 42 correction (UnifiedShell adoption):
//   - Outer wrapper migrated from <ModeShell mode="brief"> to
//     <UnifiedShell mode="brief"> so /brief/history shares the same
//     institutional chrome as /home and /brief. Keeps the Brief
//     family visually consistent — clicking the History sub-nav
//     inside <BriefShell> no longer flips the global chrome.
//   - <BriefShell> and <PhantomSlipHistoryPanel> behavior are
//     unchanged. The history panel manages its own loading / error
//     / empty states via usePhantomCycleHistory(), so opted-out
//     users continue to see the empty-list state truthfully (they
//     have no slip_cycles rows). No new hooks, no new RPCs, no
//     behavioural drift.

import { useNavigate } from "react-router-dom";
import { BriefShell } from "../../modes/brief/BriefShell.tsx";
import { MODE_ROUTE_PREFIXES } from "../../modes/mode-config.ts";
import { UnifiedShell, type UnifiedMode } from "../../shell/index.ts";
import { PhantomSlipHistoryPanel } from "../dashboard/PhantomSlipHistoryPanel.tsx";

export function BriefHistoryPage(): JSX.Element {
  const navigate = useNavigate();

  function handleNavigate(next: UnifiedMode): void {
    navigate(MODE_ROUTE_PREFIXES[next]);
  }

  return (
    <UnifiedShell
      mode="brief"
      contextEyebrow="THE BRIEF"
      contextTitle="Phantom history"
      safetyLabel="PHANTOM · SAFE MODE"
      accountLabel="1A"
      onNavigate={handleNavigate}
    >
      <BriefShell
        eyebrow="The Brief"
        title="Phantom slip history"
        description="Resolved simulated Phantom slips for this account. Most recent first. Every row is a deterministic Phantom outcome — no live match result, no real money, no agent reasoning."
      >
        <PhantomSlipHistoryPanel />
      </BriefShell>
    </UnifiedShell>
  );
}
